export default __webpack_public_path__ + "static/media/server-room.442d0378.jpg";